import React from "react";
import ReactDOM from 'react-dom';

let creator_wrapper = document.getElementsByClassName("creator_wrapper")[0];

export default class CustomizationPortal extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return ReactDOM.createPortal(
            this.props.children,
            creator_wrapper
        );
    }
}